import dynamic from "next/dynamic";

export const DynamicContent005 = dynamic(() => import("./Content005"), {
  suspense: true,
});
